// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__16Zr9","bigColWidth":"Table_bigColWidth__1H7_g","biggerColWidth":"Table_biggerColWidth__1lsPS","row":"Table_row__3CqyC","col":"Table_col__1vLt0"};